import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader } from '../components/Loader';

interface NoAuthGuardProps {
    children: React.ReactElement;
}

export const NoAuthGuard: React.FC<NoAuthGuardProps> = ({ children }) => {
    const { authenticated, check, isInitializing } = useAuth();
    const location = useLocation();
    const [isChecking, setIsChecking] = useState(true);
    const [shouldRedirect, setShouldRedirect] = useState(false);

    useEffect(() => {
        // Wait for auth initialization to complete
        if (isInitializing) {
            return;
        }

        const verifyAuth = async () => {
            setIsChecking(true);
            const isAuth = await check();
            
            // Check for token in URL
            const urlParams = new URLSearchParams(window.location.search);
            const hashParams = new URLSearchParams(window.location.hash.split('?')[1] || '');
            const hasUserToken = urlParams.get('token') || hashParams.get('token');

            if (isAuth && !hasUserToken) {
                // Admin-only application - always redirect to dashboard
                setShouldRedirect(true);
            }
            
            setIsChecking(false);
        };

        verifyAuth();
    }, [isInitializing, check, location]);

    if (isInitializing || isChecking) {
        return <Loader fullScreen={true} />;
    }

    if (shouldRedirect) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};
